<template>
  <div
    class="ce-boolFilter"
    :class="[{'is-open': isOpen }]">
    <div
      class="ce-boolFilter-toggle flex"
      @click="toggle">
      <div class="flex-auto">
        {{ label }}
        <span
          class="ms-1 ml1"
          v-if="activeOption && activeOption.value > 1">
          ("{{ activeOption.title }}" {{ $t('filter.selected') }})
        </span>
      </div>
      <div class="ce-boolFilter-toggleIndicator">
        <fa-icon :icon="['fas', 'angle-down']" />
      </div>
    </div>

    <div
      v-show="isOpen"
      class="ce-boolFilter-content">
      <ul class="list-reset">
        <li
          v-for="option in options"
          :class="{active: activeOption.value === option.value}"
          :key="option.value"
          @click="select(option.value)">
          {{ option.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DropDownMixin from 'src/mixins/DropDown';
import { translate } from 'utils/i18n';

export default {
  props: {
    filterKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      containerClass: 'ce-boolFilter'
    };
  },
  mixins: [DropDownMixin],
  computed: {
    ...mapGetters(['urlFilters']),
    options() {
      return [
        {
          value: 1,
          title: translate('filter.boolFilter.any')
        },
        {
          value: 2,
          title: translate('filter.boolFilter.yes')
        },
        {
          value: 3,
          title: translate('filter.boolFilter.no')
        }
      ];
    },
    activeOption() {
      const val = this.urlFilters[this.filterKey];

      if (val === true) return this.getOption(2);
      if (val === false) return this.getOption(3);

      return this.getOption(1);
    }
  },
  methods: {
    getOption(value) {
      return this.options.find((option) => option.value === value);
    },
    select(value) {
      const url = this.$cloneObject(this.urlFilters);
      this.$trackEvent('filter', 'toggle', {
        filterType: 'bool',
        filterKey: this.filterKey,
        filterLabel: this.label,
        value
      });

      switch (value) {
        case 1:
          delete url[this.filterKey];
          break;
        case 2:
          url[this.filterKey] = true;
          break;
        case 3:
          url[this.filterKey] = false;
          break;
        default:
          delete url[this.filterKey];
      }

      this.$store.dispatch('setUrlFilters', url).then(() => {
        this.close();
      });
    }
  }
};
</script>

<style lang="less">
  @import (reference) "~styles/includes/base";

  .ce-boolFilter {
    position: relative;
    margin-bottom: @space-3;

    .ce-boolFilter-toggle {
      background: @ce-filter-background-color;
      color: @ce-filter-color;
      font-weight: 500;
      padding: @space-2 @space-3;
      border: 1px solid @ce-filter-border-color;
      border-radius: @border-radius;
      cursor: pointer;
      .noselect();

      .ce-boolFilter-toggleIndicator {
        transition: transform 250ms ease;
        color: @ce-filter-highlight-color;

        svg {
          pointer-events: none;
        }
      }
    }

    &.is-open {
      .ce-boolFilter-toggle {
        .ce-boolFilter-toggleIndicator {
          transform: rotate(-180deg);
        }
      }
    }

    .ce-boolFilter-content {
      position: absolute;
      top: 100%;
      margin-top: @space-1;
      left: 0;
      width: 100%;
      background: @color-mono-100;
      z-index: 1000;
      color: @color-mono-20;
      border-radius: @border-radius;
      border: 2px solid darken(@ce-filter-background-color, 10);

      ul {
        margin: 0;

        li {
          padding: @space-2;
          cursor: pointer;
          color: @ce-filter-color;
          .noselect();

          &:hover, &.active {
            background: darken(@color-mono-95, 5);
          }
        }
      }
    }
  }
</style>
